import gbAntPagination from "./src/gb-ant-pagination.vue";
const gbAntPaginationCompenet = function(Vue) {
  Vue.component(gbAntPagination.name, gbAntPagination);
};
export default gbAntPaginationCompenet;
